import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

const initialState = {
    title: null,
    preTitle: {},
    state: {}
}
let NavigateStore = (set, get) => ({
    ...initialState,
    setNavigateStore: async (data, prev, state) => {
        try {
            set({ ...initialState, title: data, preValue: prev, state })
        } catch (err) {
            console.warn(err)
        }
    }

})

NavigateStore = persist(NavigateStore, { name: 'NavigateStore' })
export const useNavigateStore = create(devtools(immer(NavigateStore)))
